import React, {useEffect, useRef, useState} from 'react';
import styles from "./MainPage.module.css";
import MenuButton from "../../components/MenuButton/MenuButton";
import UserInfoForm from "../UserInfoForm/UserInfoForm";
import {defaultSiteTabTitle} from "../../AppVars";
import {Button} from "@mui/material";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";
import ServerManager from "../../API/ServerManager";
import globalCalls from "../../modules/GlobalCalls";
import {removeLastLoginWorkDayStamp} from "../../utils/LoginUtil";
import {allModes, allSubModes} from "./MainPageModes";

const MainPage = () => {

    const [expandedMode, setExpandedMode] = useState(null); // режим, для которого в меню добавлены доп. пункты "добавить/редактировать" (или null, если нет)
    const [tabs, setTabs] = useState([]); // список имеющихся табов
    const [activeTab, setActiveTab] = useState(null); // активный таб (или null, если нет)
    const [isLoading, setIsLoading] = useState(false);

    // меняем заголовок на вкладке страницы в зависимости от выбранного таба
    useEffect(() => {
        document.title = activeTab ? getTabTitle(activeTab) : defaultSiteTabTitle;
    }, [activeTab]);

    // формируем элементы меню
    function getMenuItems() {
        const result = [];
        for (const mode of allModes) {
            if (!mode.isInMenu)
                continue;

            // "обычный" элемент
            result.push(createMenuItem("normal", mode, undefined, mode.title, `mode_${mode.name}`, (mode === expandedMode)))

            if (mode === expandedMode) {
                for (const subMode of allSubModes) {
                    // "доп." элемент
                    if (subMode.name !== "add" || !mode.disableAddOption)
                        result.push(createMenuItem("sub", mode, subMode, subMode.title, `submode_${subMode.name}`));
                }
            }
        }
        return result;
    }

    function createMenuItem(type, mode, subMode, label, key, selected) {
        return {type: type, mode: mode, subMode: subMode, label: label, key: key, selected: selected}
    }

    function getTabForm(tab) {
        const Component = tab.mode.formComponent;
        return <Component key={tab.key} isAddSubMode={tab.subMode.isAdd}/>
    }

    function onMenuItemClick(item) {
        if (item.type === "normal" && expandedMode === item.mode) {
            setExpandedMode(null);
        } else if (item.type === "normal" && item.mode.isExpandable) {
            setExpandedMode(item.mode);
        } else if (item.type === "sub") {
            const tab = addTab(item.mode, item.subMode);
            setActiveTab(tab);
            setExpandedMode(null);
        }
    }

    function addTab(mode, subMode) {
        const tab = {
            key: new Date().getTime(),
            mode: mode,
            subMode: subMode,
        }

        setTabs([...tabs, tab])
        return tab;
    }

    function onTabCloseBtnClick(tab) {
        const updatedTabs = tabs.filter(x => x !== tab);
        setTabs(updatedTabs);

        if (tab === activeTab)
            setActiveTab(updatedTabs.length > 0 ? updatedTabs[0] : null); // TODO? переключаться не на первый, а на соседний таб?
    }

    async function onLogoutBtnClick() {
        setIsLoading(true);

        try {
            removeLastLoginWorkDayStamp();
            await ServerManager.logout();
            globalCalls.logout();
        } catch (error) {
        }

        setIsLoading(false);
    }

    const tabsRef = useRef(null);

    function onTabsWheel(e){
        if (tabsRef.current)
            tabsRef.current.scrollLeft += e.deltaY;
    }

    return (
        <div className={styles.mainFormContent}>
            {isLoading && <LoadingOverlay open={true}/>}
            <div className={styles.header}>
                <div
                    className={styles.tabs}
                    ref={tabsRef}
                    onWheel={onTabsWheel}
                >
                    {tabs.map(tab => (
                        <div
                            key={tab.key}
                            className={`${styles.tab} ${tab === activeTab ? styles.activeTab : ''}`}
                            onClick={() => setActiveTab(tab)}
                            onAuxClick={e => {
                                if (e.button === 1) {
                                    e.stopPropagation();
                                    onTabCloseBtnClick(tab);
                                }
                            }}
                        >
                            <div className={styles.tabLabel}>
                                <div className={styles.tabLabelMain}>
                                    {tab.mode.title}
                                </div>
                                <div className={styles.tabLabelSub}>
                                    {tab.subMode.tabTitle}
                                </div>
                            </div>
                            <button onClick={(e) => {
                                e.stopPropagation();
                                onTabCloseBtnClick(tab);
                            }}>
                                ×
                            </button>
                        </div>
                    ))}
                </div>
                <Button variant="contained"
                        style={{marginLeft: "auto", flexBasis: "80px", flexGrow: "0", flexShrink: "0"}}
                        onClick={onLogoutBtnClick}>выйти</Button>
            </div>
            <div className={styles.mainFormMain}>
                <div className={styles.mainFormMainLeft}>
                    {getMenuItems().map(item =>
                        <MenuButton
                            label={item.label}
                            type={item.type}
                            onClick={() => onMenuItemClick(item)}
                            key={item.key}
                            selected={item.selected}
                            notificationEffectFunc={item.type === "normal" ? item.mode.notificationEffectFunc : undefined}
                        />
                    )}
                </div>
                <div className={styles.mainFormMainForms}>
                    {activeTab ? getTabForm(activeTab) : <UserInfoForm/>}
                </div>
            </div>
        </div>
    );
};

function getTabTitle(tab) {
    return `${tab.mode.title} [${tab.subMode.tabTitle}]`;
}

export default MainPage;